<template>
    <div class="complaint">
        <el-table
                :data="tablePjData"
                height="400"
                stripe
                border
                style="width: 100%">
            <el-table-column
                    align="center"
                    prop="created_at"
                    label="投诉时间"
                    width="200">
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="company_name"
                    label="投诉车队"
                    width="270">
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="content"
                    label="投诉内容"
                    width="409">
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="status"
                    label="处理结果"
                    width="120">
                <template slot-scope="scope">
                    <span v-if="scope.row.status == 1" class='yhfType'>处理中</span>
                    <span v-else class='whfType'>未处理</span>
                </template>
            </el-table-column>
            <!--<el-table-column
                    align="center"
                    prop="operation"
                    label="操作"
                    width="180">
                <template slot-scope="scope">
                    <el-button class="zhuangtaiText">{{ scope.row.status == 0 ?
                        '未申请' : (scope.row.status == 1 ? '已申请' : (scope.row.status
                        == 2 ? '通过' : (scope.row.status == 3 ? '驳回' : ''))) }}
                    </el-button>
                    <el-button class="detailColor"
                               @click="yhpjDetailClick(scope.row)" type="text"
                               size="small">详情
                    </el-button>
                    <el-button class="hfColor" type="text" size="small"
                               @click="yhpjDetailClick(scope.row)">回复
                    </el-button>
                </template>
            </el-table-column>-->
        </el-table>
    </div>
</template>

<script>
    export default {
        name: "complaint",
        data() {
            return {
                // 评价列表数据
                tablePjData: [],
            }
        },
        methods:{
          myComplaintList(){
            this.$axios.get("/myComplaintList").then((res)=>{
              // console.log(res);
              res = res.data;
              if (res.status == 200) {
                this.tablePjData = res.data;
              } else {
                // layer.msg(res.msg, {icon: 2});
                  this.$message(res.msg);
              }//请求成功返回的数据
            })
          }
        },
        mounted() {
          this.myComplaintList();
        },
    }
</script>

<style scoped>
    .complaint {

    }

    .yhfType {
        display: inline-block;
        width: 66px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        color: #666;
        font-size: 14px;
    }

    .whfType {
        display: inline-block;
        width: 66px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        color: #CF0000;
        font-size: 14px;
    }

</style>



// WEBPACK FOOTER //
// src/pages/persondata/children/complaint.vue